export const profileSections = [
  {
    nameKey: 'platform.logout',
    name: 'Выйти',
    action: 'logout',
    icon: 'pi pi-sign-out',
  },
]
